<template>
  <div>
    <div v-if="!isOtherWall" class="big-profile">
      <div class="bigProfileImgDiv">
        <img class="bigProfileImg" :src="userInfo.profile_picture || defaultProfileImage" alt />
      </div>
      <router-link :to="{
          name: 'userSettings',
        }">
        <b-button class="go-to-edit-profile-btn" block squared>
          <i class="far fa-edit"></i> EDIT PROFILE
        </b-button>
      </router-link>
      <div class="big-page-paraghraph">
        <h2 class="bigName">
          {{ `${ userInfo.first_name || 'Name' } ${ userInfo.last_name || 'Surname' }` }}
        </h2>
        <p class="big-work-info">{{ userInfo.job_title || 'No Job' }}</p>
        <router-link
          :to="{
            name: 'companyProfile',
            params: { companyId: getId(userInfo.company) }
          }"
        >
            <p class="big-profile-text">
              {{ userInfo.company_name || 'No Company' }}
            </p>
        </router-link>
        <hr class="user-profile-hr" />
        <UserNetwork :customer-id="$route.params.customerId" class="user-network" />
        <hr class="user-profile-hr" />
      <IndustryTags />
      </div>
    </div>
    <div v-else class="smallProfile">
      <img class="smallProfileImg" :src="isOwner
        ? userInfo.profile_picture || defaultProfileImage
        : otherUserInfo.profile_picture || defaultProfileImage" alt />
      <div class="small-page-paraghraph">
        <h6 class="m-0">
          <span class="user-small-page-name">
            {{ isOwner ? userInfo.first_name || 'Name' : otherUserInfo.user.first_name || 'Name' }}
          </span>
          <span class="user-small-page-name">
            {{ isOwner ? userInfo.last_name || 'Surname' : otherUserInfo.user.last_name || 'Surname' }}
          </span>
        </h6>
        <p class="title">{{ isOwner ? userInfo.job_title || 'No Job' : otherUserInfo.job_title || 'No Job' }}</p>
        <router-link
          :to="{
            name: 'companyProfile',
            params: { companyId: getId(isOwner ? userInfo.company : otherUserInfo.company) }
          }"
        >
          <p class="comp-name">
            {{ isOwner ? userInfo.company_name || 'No Company' : otherUserInfo.company_name || 'No Company' }}
          </p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UserNetwork from '../UserNetwork.vue';
import getIDfromURL from '../../utils/getIDfromURL';
import defaultProfileImage from '../../assets/default-user-profile-image.png';
import IndustryTags from './IndustryTags.vue';

export default {
  name: 'Profile',
  components: {
    UserNetwork,
    IndustryTags,
  },
  props: {
    isOtherWall: {
      type: Boolean,
    },
    isOwner: {
      type: Boolean,
      default: true,
    },
    otherUserInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defaultProfileImage,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
    }),
  },
  methods: {
    getId(url) {
      return getIDfromURL(url);
    },
  },
};
</script>

<style scoped>

.bigProfileImgDiv {
  display: flex;
}
.bigProfileImg {
  width: 150px;
  flex-basis: 400px;
  box-shadow: 0px 0px 0px 1px #dedede;
  background: white;
  object-fit: cover;
  border-radius: 0 10px 0 0;
}
.big-page-paraghraph {
  border-radius: 1px;
  background-color: #ffffff;
  text-align: center;
  border-radius: 0 0 10px 10px;
}
.big-profile-text,
.big-work-info {
  color: gray;
  margin-bottom: -5px;
  cursor: pointer;
  text-transform: capitalize;
  font-size: 14px;
  font-family: Arial;
}
.bigName {
  color: #333333;
  font-size: 22px;
  font-weight: bold;
  padding-top: 17px;
  margin-bottom: 1px;
  text-transform: capitalize;
}
.big-profile-text {
  color: #BD9D5F;
  margin-bottom: 9px;
  font-size: 14px;
  font-family: Arial;
  padding: 0px 10px;
}
.group-contact {
  font-size: 17px;
  color: #BD9D5F;
  border: 1px solid whitesmoke;
  padding: 7px;
}
.user-profile-hr {
  background: whitesmoke;
  margin: 0rem;
}
.smallProfile {
  display: flex;
  height: 61px;
}
.smallProfileImg {
  width: 61px;
  height: 61px;
  background: white;
  border-right: 1px solid gainsboro;
  object-fit: cover;
}
.small-page-paraghraph {
  min-width: 0;
  flex: 1 1 0;
  border-radius: 1px;
  background-color: #ffffff;
  text-align: left;
  padding: 10px;
  line-height: 13px;
}
.title {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  height: 1.2em;
  white-space: nowrap;
  font-size: 10px;
  color: #666666;
  margin: 0px;
}
.comp-name {
  font-size: 10px;
  color: #BD9D5F;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.small-page-paraghraph > .user-small-page-name {
  font-weight: bold;
  margin: 0;
}
.go-to-edit-profile-btn {
  background-color: #BD9D5F;
  box-shadow: none;
  border: 0;
  height: 37px;
  font-family: Arial;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  margin-top: 1px;
}
.go-to-edit-profile-btn:active {
  box-shadow: none !important;
}
.user-network{
  height: 36px;
  padding-top: 6px;
}
@media (max-width:768px) {
  .smallProfile {
    width: 100%;
    height: 60px;
  }
  .smallProfileImg {
    width: 60px;
    height: 60px;
  }
}
</style>
